/* Jersey Pickles Premium Theme JS v2 */

(function() {
  'use strict';

  /* --- Sticky Header --- */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  function closeMobileNav() {
    if (menuToggle) menuToggle.classList.remove('active');
    if (mobileNav) mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('open');
      menuToggle.classList.toggle('active');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
    mobileNav.querySelectorAll('a').forEach(function(link) { link.addEventListener('click', closeMobileNav); });
  }

  /* --- Smart / Predictive Search --- */
  var search = document.querySelector('[data-search]');
  if (search) {
    var sToggle = search.querySelector('[data-search-toggle]');
    var sInput = search.querySelector('[data-search-input]');
    var sResults = search.querySelector('[data-search-results]');
    var sClose = search.querySelector('[data-search-close]');
    var sForm = search.querySelector('.header-search-form');
    var searchTimer;

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function openSearch() {
      search.classList.add('open');
      sToggle.setAttribute('aria-expanded', 'true');
      setTimeout(function() { sInput.focus(); }, 80);
    }
    function closeSearch() {
      search.classList.remove('open');
      sToggle.setAttribute('aria-expanded', 'false');
    }

    sToggle.addEventListener('click', function(e) {
      e.preventDefault();
      if (search.classList.contains('open')) { closeSearch(); }
      else { openSearch(); }
    });

    if (sClose) {
      sClose.addEventListener('click', function(e) {
        e.preventDefault();
        sInput.value = '';
        sResults.innerHTML = '';
        closeSearch();
      });
    }

    /* Close when clicking outside or pressing Escape */
    document.addEventListener('click', function(e) {
      if (search.classList.contains('open') && !search.contains(e.target)) closeSearch();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && search.classList.contains('open')) closeSearch();
    });

    /* Reward-only products: earned by hitting a cart threshold, never findable
       on their own. The GWP tee is priced $0 in Shopify so the drawer can add
       it free at $120 — if search surfaced it, anyone could take it for nothing.
       Keep this list in sync with gwp_handle in sections/cart-drawer.liquid. */
    var REWARD_ONLY_HANDLES = ['big-dill-hat-gift', 'big-dill-energy-tee', 'packaging-fee', 'cross-border-protection', 'packaging-fee-1', 'mc-order-fee', 'fee-rule'];

    function renderResults(data) {
      var products = ((data && data.resources && data.resources.results && data.resources.results.products) || [])
        .filter(function(p) { return REWARD_ONLY_HANDLES.indexOf(p.handle) === -1; });
      var q = sInput.value.trim();
      if (!products.length) {
        sResults.innerHTML = q ? '<div class="search-empty">No matches for "' + escapeHtml(q) + '"</div>' : '';
        return;
      }
      var html = products.slice(0, 6).map(function(p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var price = (p.price !== undefined && p.price !== null && p.price !== '')
          ? '$' + parseFloat(p.price).toFixed(2) : '';
        return '<a class="search-result" href="' + p.url + '" role="option">'
          + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="search-result-noimg"></span>')
          + '<span class="search-result-info">'
          + '<span class="search-result-title">' + escapeHtml(p.title) + '</span>'
          + (price ? '<span class="search-result-price">' + price + '</span>' : '')
          + '</span></a>';
      }).join('');
      html += '<a class="search-result-all" href="/search?q=' + encodeURIComponent(q) + '">See all results &rarr;</a>';
      sResults.innerHTML = html;
    }

    sInput.addEventListener('input', function() {
      var q = sInput.value.trim();
      clearTimeout(searchTimer);
      if (!q) { sResults.innerHTML = ''; return; }
      sResults.innerHTML = '<div class="search-loading">Searching&hellip;</div>';
      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function(r) { return r.json(); })
          .then(renderResults)
          .catch(function() { sResults.innerHTML = ''; });
      }, 200);
    });

    /* Let Enter submit straight to the full results page */
    if (sForm) {
      sForm.addEventListener('submit', function() {
        if (!sInput.value.trim()) return false;
      });
    }
  }

  /* --- Cart Drawer Open/Close --- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');

  /* Mirror the drawer's open state onto <body> so overlapping UI (e.g. the
     floating live-chat bubble) can hide while it's open. A MutationObserver
     catches EVERY path that toggles .open — theme.js, PDP add-to-cart, the
     GWP free-bag sync — not just openCart()/closeCart() below. */
  if (cartDrawer) {
    var syncCartOpenFlag = function() {
      /* The fees app (vol-fees-surcharge · chargefee-runtime.js) re-renders the drawer after a cart
         change and copies the server's class list onto it, which drops .open while the overlay stays
         up: the drawer slides away ~1.5 s after "Add to cart" and the page is left dimmed and
         scroll-locked (seen 2026-10-09). The overlay is the source of truth — closeCart() always
         clears both in the same tick — so while it's active the drawer stays open. */
      if (cartOverlay && cartOverlay.classList.contains('active') && !cartDrawer.classList.contains('open')) {
        cartDrawer.classList.add('open');
        return;
      }
      document.body.classList.toggle('cart-drawer-open', cartDrawer.classList.contains('open'));
    };
    var drawerClassWatch = new MutationObserver(syncCartOpenFlag);
    drawerClassWatch.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    syncCartOpenFlag();

    /* Since 2026-10-15 the same app can also swap the whole overlay + drawer for fresh, closed copies
       (home quick adds): the cart flashed open for ~0.3 s, the page stayed scroll-locked, and every
       reference above pointed at the detached nodes (so the cart icon and ✕ stopped working too).
       Watch the section for swapped nodes: carry the open state over and re-point at the new ones. */
    var cartSection = cartDrawer.parentElement;
    if (cartSection) {
      new MutationObserver(function(ms) {
        var swapped = false, wasOpen = false;
        ms.forEach(function(m) {
          Array.prototype.forEach.call(m.removedNodes, function(n) {
            if (n.nodeType !== 1) return;
            if (n.matches('[data-cart-drawer]')) { swapped = true; if (n.classList.contains('open')) wasOpen = true; }
            if (n.matches('[data-cart-overlay]')) { swapped = true; if (n.classList.contains('active')) wasOpen = true; }
          });
        });
        if (!swapped) return;
        var d = cartSection.querySelector('[data-cart-drawer]');
        if (!d) return;
        cartDrawer = d;
        cartOverlay = cartSection.querySelector('[data-cart-overlay]');
        drawerClassWatch.disconnect();
        drawerClassWatch.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
        if (wasOpen) {
          if (cartOverlay) cartOverlay.classList.add('active');
          cartDrawer.classList.add('open');
        }
        syncCartOpenFlag();
      }).observe(cartSection, { childList: true });
    }
  }

  function openCart() {
    /* Open drawer immediately */
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    /* Then sync cart data */
    syncCartDrawer();
  }

  function syncCartDrawer() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      /* Use global rebuild if available */
      if (window.rebuildCartDrawer) {
        window.rebuildCartDrawer(cart);
        return;
      }

      /* Fallback: update critical elements directly */
      var MIN = 2500;
      var total = '$' + (cart.total_price / 100).toFixed(2);

      document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });

      var countEl = document.querySelector('.cart-drawer-count');
      if (countEl) countEl.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');

      var subEl = document.querySelector('.cart-subtotal-value');
      if (subEl) subEl.textContent = total;

      var ckBtn = document.querySelector('[data-checkout-btn]');
      if (ckBtn) {
        ckBtn.disabled = cart.item_count === 0 || cart.total_price < MIN;
        if (cart.total_price < MIN && cart.item_count > 0) {
          ckBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Minimum $25.00 to checkout';
        } else {
          ckBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Secure Checkout — ' + total;
        }
      }

      /* Min order message */
      var oldMsg = document.querySelector('.cart-min-order');
      if (oldMsg) oldMsg.remove();
      if (cart.total_price < MIN && cart.item_count > 0) {
        var rem = '$' + ((MIN - cart.total_price) / 100).toFixed(2);
        var noteEl = document.querySelector('.cart-note');
        if (noteEl) {
          noteEl.insertAdjacentHTML('afterend', '<div class="cart-min-order"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg> Add ' + rem + ' more to unlock checkout</div>');
        }
      }
    })
    .catch(function() {});
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  /* Open cart buttons */
  document.querySelectorAll('[data-cart-open], .cart-button').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  /* Close cart buttons */
  document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      closeCart();
    });
  });

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Delegated too: the ✕, "Continue shopping" and the overlay may be fresh nodes swapped in by the
     fees app (see above), which never got the listeners bound at load. closeCart() is idempotent. */
  document.addEventListener('click', function(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-cart-close], [data-cart-overlay]') : null;
    if (!t) return;
    e.preventDefault();
    closeCart();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeCart(); closeMobileNav(); }
  });

  /* --- Sync Cart on Page Load --- */
  syncCartDrawer();

  /* --- Open cart drawer when arriving with #cart (e.g. from BYB summary) --- */
  if (window.location.hash === '#cart') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    setTimeout(openCart, 50);
  }

  /* --- Sticky Cart visibility on scroll --- */
  var stickyCart = document.querySelector('.sticky-cart');
  if (stickyCart) {
    window.addEventListener('scroll', function() {
      stickyCart.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
  }

  /* --- Scroll Animations --- */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.animate-in, .section-header, .hero-content, .hero-image').forEach(function(el) {
    observer.observe(el);
  });

})();
